import React, { useEffect } from 'react';
import RouteErrorPage from './RouteErrorPage';
// import useMediaQuery from './hooks/useMediaQuery';
import GlobalData, { GlobalDataContext } from './GlobalData'
import Theme from './Theme';
import Router from './Router';
import Main from './Main/Main';
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";
// import HomeDashboard from './Main/HomeDashboard/HomeDashboard';
import AdminImitatorLogin from './AdminImitatorLogin';
import MyAccount from './Main/MyAccount/MyAccount';
import SsoCallback from './sso/SsoCallback';
import '@prosolve/common-components-ui/dist/styles.css'
import consoleOverride from './consoleOverride';
import useDataVerify from './dataHooks/useDataVerify';
import useDataMe from './dataHooks/useDataMe';

consoleOverride();

// Used to wrap route and override title seen in the browser Tab --
const Page = (props) => {
  useEffect(() => {
    document.title = props.title || "";
  }, [props.title]);
  return props.children;
};

export default () => {
  // const isMobileView = useMediaQuery('(max-width: 450px)');

  const { getIsVerified } = useDataVerify()
  const { fetchMe } = useDataMe()

  const verifyLoader = async () => {
    const isVerified = await getIsVerified()
    const me = await fetchMe()
    return { ...me, isVerified }
  };

  // Example of plublic loader to use when need me but not verify
  // const publicLoader  = async () => {
  //   const me = await fetchMe()
  //   return me;
  // }

  const globalData = new GlobalData();
  // globalData.setIsMobileView(isMobileView)

  const routes = [
    {
      path: "/",
      isPrivate: true,
      loader: verifyLoader,
      element: (routeProps) => (
        <Page title='ProSolve Home'>
          <Main {...routeProps} />
        </Page>
      ),
      errorElement: (routeProps) => <RouteErrorPage {...routeProps} />,
    },
    {
      path: "/myAccount",
      isPrivate: true,
      loader: verifyLoader,
      element: (routeProps) => (
        <Page title='My Account'>
          <MyAccount />
        </Page>
      ),
    },
    {
      path: "/ssoCallback",
      element: (routeProps) => (
        <SsoCallback {...routeProps} />
      ),
    },
    // {
    //   path: "/",
    //   isPrivate: true,
    //   element: (routeProps) => (
    //     <Page title='ProSolve Home Portal'>
    //       <Main {...routeProps} />
    //     </Page>
    //   ),
    //   children: [
    //     {
    //       path: "home",
    //       element: <Home />
    //     }
    //   ],
    //   errorElement: (routeProps) => <RouteErrorPage {...routeProps} />,
    // },
    // {
    //   path: "/student",
    //   element: (routeProps) => (
    //     <Page title='ProSolve Student Portal'>
    //       <Main {...routeProps} />
    //     </Page>
    //   ),
    // },
    {
      path: "/adminImitatorLogin",
      element: (routeProps) => (
        <Page title='ProSolve Events Portal'>
          <AdminImitatorLogin {...routeProps} />
        </Page>
      ),
    },
    {
      path: "/forgotpassword",
      element: (routeProps) => (
        <Page title='ProSolve Authentication Portal'>
          <ForgotPassword {...routeProps} />
        </Page>
      ),
      errorElement: (routeProps) => <RouteErrorPage {...routeProps} />,
    },
    {
      path: "/resetPassword",
      element: (routeProps) => (
        <Page title='ProSolve Authentication Portal'>
          <ResetPassword {...routeProps} />
        </Page>
      ),
      errorElement: (routeProps) => <RouteErrorPage {...routeProps} />,
    },
  ]

  return (
    <GlobalDataContext.Provider value={globalData}>
      <Theme>
        <Router routes={routes} />
      </Theme>
    </GlobalDataContext.Provider>
  )
}